/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientMetricEvent,
  Health,
} from '../models/index';
import {
    ClientMetricEventFromJSON,
    ClientMetricEventToJSON,
    HealthFromJSON,
    HealthToJSON,
} from '../models/index';

export interface ClientMetricsPostRequest {
    clientMetricEvent: ClientMetricEvent;
}

/**
 * 
 */
export class InfrastructureApi extends runtime.BaseAPI {

    /**
     * Records bounded frontend/client-side metrics for Prometheus.
     */
    async clientMetricsPostRaw(requestParameters: ClientMetricsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientMetricEvent'] == null) {
            throw new runtime.RequiredError(
                'clientMetricEvent',
                'Required parameter "clientMetricEvent" was null or undefined when calling clientMetricsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/client-metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientMetricEventToJSON(requestParameters['clientMetricEvent']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Records bounded frontend/client-side metrics for Prometheus.
     */
    async clientMetricsPost(requestParameters: ClientMetricsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clientMetricsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Checks if the service is healthy
     */
    async healthGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Health>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthFromJSON(jsonValue));
    }

    /**
     * Checks if the service is healthy
     */
    async healthGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Health> {
        const response = await this.healthGetRaw(initOverrides);
        return await response.value();
    }

}
